import { render, staticRenderFns } from "./dangerousGoodsStorageLocationForm.vue?vue&type=template&id=ebff2418"
import script from "./dangerousGoodsStorageLocationForm.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsStorageLocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports